import { DiscountRange } from 'services/products/interfaces';
import { GetCurrentRangeProps } from './interfaces';

function getRangeValues(rangesRef: DiscountRange[], target: number) {
	const rateDiscountDefault = {
		discount: 0,
		taxSubstitution: 0,
	};

	const rateDiscountData = rangesRef.find(({ from, to }) => {
		if (to) return target >= from && target <= to;

		return target >= from;
	});

	return rateDiscountData || rateDiscountDefault;
}

export function getCurrentRange({
	ranges,
	updatedProductQuantity,
	totalPrice,
	mixedRanges,
	productPrices,
	rangeByQuantity,
	allProductQuantities,
	quantityInBasket,
	progressiveDiscount,
	hasRangeProduct,
	progressiveDiscountProductMix,
}: GetCurrentRangeProps) {
	if (ranges?.length === 1 && !mixedRanges?.length) {
		const firstRange = ranges[0];

		return {
			discount: firstRange.discount,
			taxSubstitution: firstRange.taxSubstitution,
		};
	}

	if (progressiveDiscountProductMix && hasRangeProduct && ranges)
		return getRangeValues(ranges, rangeByQuantity ? allProductQuantities : productPrices);

	if (mixedRanges?.length) {
		if (!rangeByQuantity) return getRangeValues(mixedRanges, productPrices);

		return getRangeValues(mixedRanges, progressiveDiscount ? quantityInBasket : allProductQuantities);
	}

	return getRangeValues(ranges || [], rangeByQuantity ? updatedProductQuantity : totalPrice);
}
